// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_eO","advertDetailContactGroup__header":"c-n_eP","advertDetailContactGroup__value":"c-n_eQ"};